import _ from 'lodash'

const PERSIST_USER = 'PERSIST_USER'
const PERSIST_KEYS = 'PERSIST_KEYS'

// Initial state
const state = {
  keys: JSON.parse(localStorage.getItem('keys')) === null ? {} : JSON.parse(localStorage.getItem('keys')),
  user: JSON.parse(localStorage.getItem('user')) === null ? {} : JSON.parse(localStorage.getItem('user'))
}

// Getters
const getters = {
  expressKeys: state => {
    if (Object.keys(state.keys.clientAccessKeys).length > 0) {
      return {
        access_key: _.keys(state.keys.clientAccessKeys)[0],
        iv_key: state.keys.clientAccessKeys[_.keys(state.keys.clientAccessKeys)[0]].ivKey,
        secret_key: state.keys.clientAccessKeys[_.keys(state.keys.clientAccessKeys)[0]].secretKey
      }
    }
    return {}
  },

  customApiKeys: state => {
    if (Object.keys(state.keys.oauthKeyDetails).length > 0) {
      return {
        client_id: _.keys(state.keys.oauthKeyDetails)[0],
        client_secret: state.keys.oauthKeyDetails[_.keys(state.keys.oauthKeyDetails)[0]].clientSecret
      }
    }
    return {}
  },

  clientInfo: state => {
    return {
      client_name: state.user.clientName,
      client_code: state.user.clientCode,
      client_id: state.user.clientID,
      contactEmail: state.user.contactEmail,
      contactMsisdn: state.user.contactMsisdn,
      contactPerson: state.user.contactPerson,
      businessCountryCode: state.user.businessCountryCode
    }
  },

  userInfo: state => {
    return state.user
  }
}

// Mutations
const mutations = {
  [PERSIST_USER]: (state, user) => {
    state.user = user
  },

  [PERSIST_KEYS]: (state, keys) => {
    state.keys = keys
  }
}

// Actions
const actions = {
  saveUserInformation: ({ commit }, user) => {
    localStorage.setItem('user', JSON.stringify(user))
    commit(PERSIST_USER, user)
  },

  saveUserKeys: ({ commit }, keys) => {
    localStorage.setItem('keys', JSON.stringify(keys))
    commit(PERSIST_KEYS, keys)
  },

  updateClient: ({ commit, dispatch, getters }, client) => {
    let clientInformation = _.merge({}, getters.userInfo)
    clientInformation = _.merge(clientInformation, client)
    dispatch('saveUserInformation', clientInformation)
  },

  updateUser: ({ commit, dispatch, getters }, user) => {
    let userInformation = _.merge({}, getters.userInfo)
    userInformation = _.merge(userInformation, user)
    dispatch('saveUserInformation', userInformation)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js